// Package imports
import { observer } from "mobx-react";
import { Button, Form, Tab, Tabs } from "react-bootstrap";

// Project Imports
import CardTextFieldComponent from "modules/family-details-form/components/CardTextFieldComponent";
import { BottomsheetDropdown, DatepickerModal } from "components";
import Utils from "./utils";

import SprmDetailForm from "./SPRM/sprmDetailForm";
import { useEffect, useState } from "react";
import PreNeedSelectionModalStore from "../../store/PreNeedSelectionModalStore";
import AuthStore from "modules/login/store/AuthStore";
import pragatiData from "modules/qms-flow/qms-dashboard-page/pragati-inbound-data";
import isObjectEmpty from "utils/isObjectEmpty";
import StorageKeys from "constants/StorageKeys";
import CustomerTypeConstant from "constants/CustomerTypeConstant";
import moment from "moment";

const PreNeedForm = ({ formController, hideModal, submitData, ...remainingProps }) => {



  const [existingCustomer, setExistingCustomer] = useState({})
  let selectedOption = formController.$("customer_type").value

  useEffect(() => {

    if (PreNeedSelectionModalStore.selectedProduct === '') {
      formController.$("proceed_btn").set('disabled', true)
    } else {
      formController.$("proceed_btn").set('disabled', false)
    }
  }, [PreNeedSelectionModalStore.selectedProduct, formController.$("proceed_btn").disabled])


  const handleOptionChange = (event) => {
    let selectOption = formController.$("customer_type").extra.optionList.find(item => item.value === event.target.value)
    formController.$("customer_type").set("value", selectOption.value)
  };

  const handleProductOptionChange = (event) => {
    PreNeedSelectionModalStore.setSelectedProduct(event);
    let showProductDropdown = event === "select_product_&_generate_quote" ? true : false
    localStorage.setItem(StorageKeys.SHOW_PRODUCT_DROPDOWN, showProductDropdown);
  };

  // console.log("PreNeedSelectionModalStore.selectedOption ", PreNeedSelectionModalStore.selectedOption)
  const radioStyle = {
    transform: 'scale(1.5)',
  };

  const handleValidate = async (formController) => {
    if (PreNeedSelectionModalStore.number.length < 10) {
      PreNeedSelectionModalStore.setValidateMsg(true)
      return
    }
    let data = await PreNeedSelectionModalStore.onValidateClick()
    if (data.message === "Valid Mobile number") {
      let showBtn = formController.$("pfa_sp_code").extra.showBtn
      if (showBtn) {
        let pragatiData = AuthStore.agentDetails
        await Utils.fetchHLDataAndSetValue(formController, data?.data?.pfa_code, pragatiData);
        formController.$("pfa_sp_code").value = data?.data?.pfa_code
      }
      setExistingCustomer(data.data)
    } else {
      setExistingCustomer({})
    }
  }

  const handleValidateV2 = async (formController) => {
    let value = formController.$("existing_customer_value")?.value
    const type = formController.$("existing_customer_type_option_list")?.value
    const showDOB = formController.$("dob")?.extra?.showDOB
    const valueDOB = formController.$("dob")?.value

    if (value === "") {
      formController.$("existing_customer_value").invalidate(`This field is mandatory`)
      if (showDOB && valueDOB === "") {
        formController.$("dob").invalidate(`This field is mandatory`)
      }
      return
    } else if (value !== "" && showDOB && valueDOB === "") {
      formController.$("dob").invalidate(`This field is mandatory`)
      return
    }


    let data = await PreNeedSelectionModalStore.onValidateClick(value, type, valueDOB)
    if (data?.status === "success") {
      let showBtn = formController.$("pfa_sp_code").extra.showBtn
      if (data?.data?.pfa_code !== "") {
        let pragatiData = AuthStore.agentDetails
        await Utils.fetchHLDataAndSetValue(formController, data?.data?.pfa_code, pragatiData);
        formController.$("pfa_sp_code").value = data?.data?.pfa_code
      }
      formController.$("existing_customer_value").validate()
      formController.$("dob").validate()
      setExistingCustomer(data.data)
      PreNeedSelectionModalStore.existingCustomerData = data.data
    } else {
      type?.id === "policy_number" ? AuthStore.setErrorModal(data?.message) : "" ;
      formController.$("existing_customer_value").invalidate(`Invalid ${type?.label}`)
      if (showDOB) {
        formController.$("dob").invalidate(`Invalid Date of Birth`)
      }
      setExistingCustomer({})
      PreNeedSelectionModalStore.existingCustomerData = {}
    }
  }

  const proceedBtnClick = () => {
    if (selectedOption === CustomerTypeConstant.NEW_CUSTOMER) {
      submitData()
    } else {
      let error = formController.$("existing_customer_value").error
      let value = formController.$("existing_customer_value").value
      const showDOB = formController.$("dob")?.extra?.showDOB
      let valueDOB = formController.$("dob")?.value
      let errorDOB = formController.$("existing_customer_value").error

      if (value === "") {
        formController.$("existing_customer_value").invalidate(`This field is mandatory`)
        if (showDOB && valueDOB === "") {
          formController.$("dob").invalidate(`This field is mandatory`)
        }
        return
      }
      if (error === null && value !== "" && errorDOB === null) {
        submitData()
      }
      //   if (PreNeedSelectionModalStore.number.length < 10) {
      //     PreNeedSelectionModalStore.setValidateMsg(true)
      //   } else {
      //     if (PreNeedSelectionModalStore.validateMsg || !PreNeedSelectionModalStore.validateMsgApi) {
      //       PreNeedSelectionModalStore.setValidateMsg(true);
      //       return
      //     }
      //     submitData()
      //   }
    }
  }

  const showPRName = (data) => {
    let fullName = ''
    if (data?.is_existing_cust_data?.length > 0) {
     let details =  data?.is_existing_cust_data?.find(item => item?.pr)
     fullName = details ? `${details?.first_name} ${details?.last_name} ` : ''
    }
    return fullName
  }

  return (
    <div className='bg-white modal-field-section pb-3 d-flex flex-column '>
      <div className="pre-need border mt-3 mb-2 mb-lg-0 text-center font-size-md-14 font-size-12">
        <Tabs activeKey={PreNeedSelectionModalStore.selectedProduct} onSelect={(e) => { handleProductOptionChange(e) }}>
          <Tab className="text-wrap" eventKey="select_product_&_generate_quote" title="Select Product & Generate Quote">

          </Tab>
          <Tab className="" eventKey="u2_recommends_product" title="U2 Recommends Product">
          </Tab>
        </Tabs>
      </div>

      {/* <div className="row">
        <div className={'col-6 mt-2 pt-lg-3 d-flex'}>

          <div className="mr-2">
            <input
              type="radio"
              value="select_product_&_generate_quote"
              style={radioStyle}
              checked={PreNeedSelectionModalStore.selectedProduct === 'select_product_&_generate_quote'}
              onChange={handleProductOptionChange}
            />
          </div>
          <div className="">{'Select Product & Generate Quote'}</div>

        </div>
        <div className={'col-6 mt-2 pt-lg-3 d-flex'}>
          <div className="mr-2">
            <input
              type="radio"
              value="u2_recommends_product"
              style={radioStyle}
              checked={PreNeedSelectionModalStore.selectedProduct === 'u2_recommends_product'}
              onChange={handleProductOptionChange}
            />
          </div>
          <div className="">{'U2 Recommends Product'} </div>
        </div>
      </div> */}


      <div className="row">
        <div className={'col-6 pl-lg-5 pt-lg-3 d-flex'}>

          <div className="mr-2">
            <input
              type="radio"
              value="New Customer"
              style={radioStyle}
              checked={selectedOption === CustomerTypeConstant.NEW_CUSTOMER}
              onChange={handleOptionChange}
            />
          </div>
          <div className="text-nowrap">{'New Customer'}</div>

        </div>
        <div className={'col-6 pl-lg-5 pt-lg-3 d-flex'}>
          <div className="mr-2">
            <input
              type="radio"
              value="Existing Customer"
              style={radioStyle}
              checked={selectedOption === CustomerTypeConstant.EXISTING_CUSTOMER}
              onChange={handleOptionChange}
            />
          </div>
          <div className="text-nowrap">{'Existing Customer'} </div>
        </div>
      </div>

      {selectedOption === CustomerTypeConstant.EXISTING_CUSTOMER &&
        <>
          <div className='row mt-2'>
            <div className='col-lg-6 col-12'>
              <div className='row'>
                <div className='col-12'>
                  <p className='pre-need-modal-label font-weight-medium'>{formController.$("existing_customer_type_option_list").label}</p>
                </div>
              </div>
              <BottomsheetDropdown
                dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
                menuItemStyle='d-flex justify-content-between align-items-center'
                menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
                selectedLabelKey='label'
                bottomsheetTitle={formController.$("existing_customer_type_option_list").extra.bottomSheetTitle}
                menuList={formController.$("existing_customer_type_option_list").extra.optionList}
                value={formController.$("existing_customer_type_option_list").value}
                showErrorMsg={formController.$("existing_customer_type_option_list").error !== null}
                errorMsg={formController.$("existing_customer_type_option_list").error}
                onSelect={formController.$("existing_customer_type_option_list").onChange}
                disabled={formController.$("existing_customer_type_option_list").disabled}
              />
            </div>

            <div className='col-lg-6 col-12 '>
              <div className='row'>
                <div className='col-12'>
                  <p className='pre-need-modal-label font-weight-medium'>{formController.$("existing_customer_type_option_list")?.value?.label}</p>
                </div>
              </div>
              <Form.Group className='mb-0'>
                <Form.Control
                  type={formController.$("existing_customer_type_option_list").type}
                  className='font-size-lg-12 font-size-14 font-weight-light existing-customer-value'
                  placeholder={formController.$("existing_customer_type_option_list").placeholder}
                  value={formController.$("existing_customer_value").value}
                  onChange={(e) => {
                    formController.$("existing_customer_value").validate({ showErrors: true });
                    formController.$("existing_customer_value").onChange(e);
                  }}
                  style={formController.$("existing_customer_value").error ? { border: "1px solid red" } : null}
                />
                {formController.$("existing_customer_value").error != null ? (
                  <p className='font-size-12 font-weight-light text-danger mb-0'>{formController.$("existing_customer_value").error}</p>
                ) : null}
              </Form.Group>
            </div>
            {formController.$("dob").extra.showDOB &&
              <>
                <div className='col-lg-6 col-12'> </div>
                <div className='col-lg-6 col-12 mt-1 '>
                  <div className='row'>
                    <div className='col-12'>
                      <p className='pre-need-modal-label font-weight-medium'>{formController.$("dob").label}</p>
                    </div>
                  </div>

                  <input
                    type="date"
                    id="dob"
                    name="dob"
                    className={`w-100 pre-need-dob ${formController.$("dob").error != null ? 'pre-need-dob-error' : ''}`}
                    value={formController.$("dob").value}
                    onChange={(e) => {
                      formController.$("dob").validate(),
                        formController.$("dob").onChange(e)
                    }}
                    max={moment().subtract(18, 'years').format('YYYY-MM-DD')}
                  />
                  {formController.$("dob").error != null ? (
                    <p className='font-size-12 font-weight-light text-danger mb-0'>{formController.$("dob").error}</p>
                  ) : null}
                </div>
              </>
            }

            <div className='col-lg-6 col-12'></div>
            <div className=" col-lg-6 col-12">
              <button onClick={() => handleValidateV2(formController)} type="button" class="btn btn-secondary btn-lg modal-cta-btn py-2 py-lg-1 mt-2 mb-2 mb-lg-0 font-size-14 font-size-lg-13 font-weight-medium">Validate</button>
            </div>

          </div>

          {/* </div> */}
          {/* {(PreNeedSelectionModalStore.validateMsgApi === true && PreNeedSelectionModalStore.validateMsg === false) && <span className="font-size-14 font-weight-medium text-danger">Welcome back {existingCustomer.first_name} {existingCustomer.middle_name} {existingCustomer.last_name} ! </span>} */}
          {/* {(!PreNeedSelectionModalStore.validateMsgApi && PreNeedSelectionModalStore.selectedOption === "Existing Customer") && <span className="font-size-14 font-weight-medium text-danger">Note:Kindly validate mobile Number first</span>} */}
        </>
      }
      <>
        <div className='row'>

          {/* <div className={`col-12 ${formController.$("journey_type").value.id == 1 ? 'col-lg-7 mt-2 mt-lg-4 pt-lg-3' : 'mt-3 mt-lg-4 pt-lg-3'}`}> */}

          <div className={'col-12 col-lg-6 mt-2'}>
            <div className='row'>
              <div className='col-12'>
                <p className='pre-need-modal-label font-weight-medium'>{formController.$("journey_type").label}</p>
              </div>
            </div>

            <BottomsheetDropdown
              dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemStyle='d-flex justify-content-between align-items-center'
              menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
              selectedLabelKey='label'
              bottomsheetTitle={formController.$("journey_type").extra.bottomSheetTitle}
              menuList={formController.$("journey_type").extra.optionList}
              value={formController.$("journey_type").value}
              onSelect={formController.$("journey_type").onChange}
              showErrorMsg={formController.$("journey_type").error !== null}
              errorMsg={formController.$("journey_type").error}
              disabled={false}
            />
          </div>

          {/* {formController.$("journey_type").value.id == 1 ?  */}
          <div className='col-12 col-lg-6 mt-2 d-md-block'>
            <p className={`pre-need-modal-label d-block font-weight-medium  ${formController.$("category").error ? "mt-2" : ""}`}>Category</p>
            <div className='w-100'>
              <BottomsheetDropdown
                dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
                menuItemStyle='d-flex justify-content-between align-items-center'
                menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
                selectedLabelKey={formController.$("category").extra.selectedOptionLabelKey}
                bottomsheetTitle={formController.$("category").extra.bottomSheetTitle}
                menuList={formController.$("category").extra.optionList}
                value={formController.$("category").value}
                onSelect={formController.$("category").onChange}
                showErrorMsg={formController.$("category").error !== null}
                errorMsg={formController.$("category").error}
                disabled={formController.$("category").disabled}
              />
            </div>

            {formController.$("category").value.label === "Staff" && (
              <Form.Group className='col-6 col-lg-12 mb-0 employee-code'>
                <Form.Control
                  className='font-size-lg-12 font-size-14 font-weight-light'
                  placeholder={formController.$("employee_code").placeholder}
                  value={formController.$("employee_code").value}
                  onChange={formController.$("employee_code").onChange}
                  style={formController.$("employee_code").error ? { border: "1px solid red" } : null}
                />
                {formController.$("employee_code").error != null ? <p className='font-size-11 font-weight-light text-danger'>{formController.$("employee_code").error}</p> : null}
              </Form.Group>
            )}
            {/* <CardTextFieldComponent
            className='font-size-12 font-weight-light'
            value={formController.$("location").value}
            menuList={formController.$("location").extra.optionList}
            placeholder={formController.$("location").placeholder}
            onChange={formController.$("location").onChange}
            showErrorMsg={formController.$("location").error !== null}
            errorMsg={formController.$("location").error}
            formControllerRef={formController}
            onSearch={async (value) => await Utils.fetchPincode(value, formController)}
            submitData={submitData}
          /> */}
          </div>
          {/* : null} */}

          {/* modal-new-customer-col */}
          {/* <div className='col-12 customer-Fields-container'>
          <div className='row mt-4'>
            <div className='col-12 col-lg-7'>
              <div className='row pt-1 pb-1'>
                {formController.$("customer_type").extra.optionList.map((item, index) => (
                  <div className='col-6 pr-0' key={item.id}>
                    <label className='cursor-pointer font-size-lg-12 font-size-16 font-weight-light d-inline-flex align-items-center'>
                      <input
                        className='mr-1'
                        type='radio'
                        value={item.value}
                        checked={formController.$("customer_type").value === item.value}
                        name={formController.$("customer_type").name}
                        onChange={formController.$("customer_type").onChange}
                      />{" "}
                      {item.label}
                    </label>
                  </div>
                ))}
              </div>

              {formController.$("customer_type").value === "Existing Customer" && (
                <div className='row'>
                  <div className='col-5 pr-0'>
                    <BottomsheetDropdown
                      dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
                      menuItemStyle='d-flex justify-content-between align-items-center'
                      menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
                      selectedLabelKey='label'
                      bottomsheetTitle={formController.$("existing_customer_type_option_list").extra.bottomSheetTitle}
                      menuList={formController.$("existing_customer_type_option_list").extra.optionList}
                      value={formController.$("existing_customer_type_option_list").value}
                      showErrorMsg={formController.$("existing_customer_type_option_list").error !== null}
                      errorMsg={formController.$("existing_customer_type_option_list").error}
                      onSelect={formController.$("existing_customer_type_option_list").onChange}
                      disabled={formController.$("existing_customer_type_option_list").disabled}
                    />
                  </div>

                  <div className='col-7 pl-2'>
                    <Form.Group className='mb-0'>
                      <Form.Control
                        type={formController.$("existing_customer_type_option_list").type}
                        className='font-size-lg-12 font-size-14 font-weight-light existing-customer-value'
                        placeholder={formController.$("existing_customer_type_option_list").placeholder}
                        value={formController.$("existing_customer_value").value}
                        onChange={(e) => {
                          formController.$("existing_customer_value").validate({ showErrors: true });
                          formController.$("existing_customer_value").onChange(e);
                        }}
                        style={formController.$("existing_customer_value").error ? { border: "1px solid red" } : null}
                      />
                      {formController.$("existing_customer_value").error != null ? (
                        <p className='font-size-11 font-weight-light text-danger'>{formController.$("existing_customer_value").error}</p>
                      ) : null}
                    </Form.Group>
                  </div>
                </div>
              )}
            </div>

            <div className='col-12 col-lg-5 modal-category-col mt-4 mt-lg-0'>
              <div className='row'>
                {/* <div className={`d-flex flex-column flex-lg-row ${formController.$("category").error ? "" : "align-items-lg-center"} mb-lg-2 col-12 col-lg-12`}>
                  <p className={`pre-need-modal-label d-block font-weight-medium mr-1 mb-lg-0 font-size-14 font-size-lg-10 ${formController.$("category").error ? "mt-2" : ""}`}>Category</p>
                  <div className='w-100'>
                    <BottomsheetDropdown
                      dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
                      menuItemStyle='d-flex justify-content-between align-items-center'
                      menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
                      selectedLabelKey={formController.$("category").extra.selectedOptionLabelKey}
                      bottomsheetTitle={formController.$("category").extra.bottomSheetTitle}
                      menuList={formController.$("category").extra.optionList}
                      value={formController.$("category").value}
                      onSelect={formController.$("category").onChange}
                      showErrorMsg={formController.$("category").error !== null}
                      errorMsg={formController.$("category").error}
                      disabled={formController.$("category").disabled}
                    />
                  </div>
                </div> */}

          {/* {formController.$("category").value.label === "Staff" && (
                  <Form.Group className='col-6 col-lg-12 mb-0 employee-code'>
                    <Form.Control
                      className='font-size-lg-12 font-size-14 font-weight-light'
                      placeholder={formController.$("employee_code").placeholder}
                      value={formController.$("employee_code").value}
                      onChange={formController.$("employee_code").onChange}
                      style={formController.$("employee_code").error ? { border: "1px solid red" } : null}
                    />
                    {formController.$("employee_code").error != null ? <p className='font-size-11 font-weight-light text-danger'>{formController.$("employee_code").error}</p> : null}
                  </Form.Group>
                )} */}

          {/* { formController.$("journey_type").value.id == 1 &&
                <div className='col-12 col-lg-5 mt-4 pt-lg-3 d-md-none'>
                  <p className='pre-need-modal-label font-weight-medium'>Location</p>
                  <CardTextFieldComponent
                    className='font-size-12 font-weight-light'
                    value={formController.$("location").value}
                    menuList={formController.$("location").extra.optionList}
                    placeholder={formController.$("location").placeholder}
                    onChange={formController.$("location").onChange}
                    showErrorMsg={formController.$("location").error !== null}
                    errorMsg={formController.$("location").error}
                    onSearch={async (value) => await Utils.fetchPincode(value, formController)}
                    submitData = {submitData}
                  />
                </div>} */}

          {/* </div>
            </div>
          </div>
        </div> */}
          {/* <div className='col-12 col-lg-7'>
          <div className='row mt-4'>
            <div className='col'>
              <p className='pre-need-modal-label font-weight-medium'>Individual's Occupation</p>
            </div>
          </div>

          <div className='row'>
            <div className='col'>
              <BottomsheetDropdown
                dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
                menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
                menuItemStyle='d-flex justify-content-between align-items-center'
                selectedLabelKey={formController.$("occupation").extra.selectedOptionLabelKey}
                bottomsheetTitle={formController.$("occupation").extra.bottomSheetTitle}
                menuList={formController.$("occupation").extra.optionList}
                value={formController.$("occupation").value}
                onSelect={formController.$("occupation").onChange}
                showErrorMsg={formController.$("occupation").error !== null}
                errorMsg={formController.$("occupation").error}
                disabled={formController.$("occupation").disabled}
              />
            </div>
          </div>

          <div className='row mt-4'>
            <div className='col'>
              <p className='pre-need-modal-label font-weight-medium'>Individual's Education</p>
            </div>
          </div>

          <div className='row'>
            <div className='col'>
              <BottomsheetDropdown
                dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
                menuItemStyle='d-flex justify-content-between align-items-center'
                menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
                selectedLabelKey={formController.$("education").extra.selectedOptionLabelKey}
                bottomsheetTitle={formController.$("education").extra.bottomSheetTitle}
                menuList={formController.$("education").extra.optionList}
                value={formController.$("education").value}
                onSelect={formController.$("education").onChange}
                showErrorMsg={formController.$("education").error !== null}
                errorMsg={formController.$("education").error}
                disabled={formController.$("education").disabled}
              />
            </div>
          </div>
        </div> */}
        </div>

        {/* SP/RM Detail Form */}
        <SprmDetailForm formController={formController} />
      </>
      {
        (!isObjectEmpty(existingCustomer) && selectedOption === 'Existing Customer') &&
        <span className="font-size-14 font-weight-medium text-danger">Welcome back {showPRName(existingCustomer)} ! </span>
      }
      {/* {(!PreNeedSelectionModalStore.validateMsgApi && PreNeedSelectionModalStore.selectedOption === "Existing Customer") &&
        <span className="font-size-14 font-weight-medium text-danger">Note:Kindly validate mobile Number first</span>
      } */}

      <div className='row  mt-sm-2 mb-3'>
        <div className='col-12 col-lg-7 mt-lg-1 mt-2'>
          <div className='row'>
            <div className='col-12 col-lg-6 mb-2 mb-lg-0 pb-1 pb-lg-0 order-0 order-lg-1 pl-lg-1'>
              <button className='btn btn-link btn-lg modal-cta-btn modal-cta-btn-link py-2 py-lg-1 font-size-14 font-weight-medium' onClick={() => Utils.handleModalExit(remainingProps, hideModal)}>
                Exit Tool
              </button>
            </div>

            <div className='col-12 col-lg-6 mb-3 mb-lg-0  order-1 order-lg-0 pr-lg-1'>
              <button
                type='submit'
                disabled={formController.$("proceed_btn").disabled}
                className='btn btn-secondary btn-lg modal-cta-btn py-2 py-lg-1 font-size-14 font-weight-medium'
                onClick={() => {


                  let locationArray = formController.$("location").extra.optionList
                  if (locationArray.length !== 0) {
                    formController.$("location").value = locationArray
                  }

                  let showBtn = formController.$("pfa_sp_code")?.extra?.showBtn
                  let pfaSpCode = formController.$("pfa_sp_code")?.value
                  let pfaSpName = formController.$("pfa_sp_name")?.value
                  if (showBtn && pfaSpCode !== "" && pfaSpName === ""){
                    return
                  }

                    proceedBtnClick()


                }}
              >
                Proceed
              </button>

            </div>
          </div>

        </div>
      </div>
    </div >
  );
};

export default observer(PreNeedForm);